export default __webpack_public_path__ + "static/media/anssid.93348350.svg";